export default "__VITE_ASSET__a2ogDbRl__"